module.exports = __webpack_public_path__ + "static/media/4.d06b6fe4.jpg";